
import { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { useCloudFunction } from './useCloudFunction';
import { trackEvent } from '../config/analytics';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export const useSubscription = () => {
  const [loading, setLoading] = useState(false);
  const { execute: createCheckout } = useCloudFunction('createSubscriptionCheckout');
  const { execute: createPortal } = useCloudFunction('createPortalSession');

  const subscribeToPlan = async (priceId, tierId) => {
    try {
      setLoading(true);
      
      trackEvent('subscription_initiated', { tier: tierId });

      const result = await createCheckout({ priceId, tierId });
      
      const stripe = await stripePromise;
      await stripe.redirectToCheckout({ sessionId: result.sessionId });
      
    } catch (err) {
      console.error('Error creating checkout:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const manageBilling = async () => {
    try {
      setLoading(true);
      
      trackEvent('billing_portal_opened');

      const result = await createPortal();
      window.location.href = result.url;
      
    } catch (err) {
      console.error('Error opening portal:', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    subscribeToPlan,
    manageBilling,
    loading,
  };
};
